import { Slider } from '@heroui/react';
import React, { FC } from 'react';

import { FieldLabel, FieldStack, FieldValue } from './Controls.styled';

interface SliderFieldProps {
  label: string;
  value: number;
  min: number;
  max: number;
  step?: number;
  /** Jednostka dopisywana przy wartości, np. `px` albo `%`. */
  suffix?: string;
  onChange: (value: number) => void;
  onChangeEnd?: (value: number) => void;
}

const single = (value: number | number[]): number => (Array.isArray(value) ? value[0] : value);

export const SliderField: FC<SliderFieldProps> = ({
  label,
  value,
  min,
  max,
  step = 1,
  suffix,
  onChange,
  onChangeEnd,
}) => (
  <FieldStack>
    <div className="flex items-center justify-between">
      <FieldLabel>{label}</FieldLabel>
      <FieldValue>{`${Math.round(value * 100) / 100}${suffix ?? ''}`}</FieldValue>
    </div>
    <Slider
      size="sm"
      minValue={min}
      maxValue={max}
      step={step}
      value={value}
      onChange={(next) => onChange(single(next))}
      onChangeEnd={onChangeEnd ? (next) => onChangeEnd(single(next)) : undefined}
      aria-label={label}
    />
  </FieldStack>
);
